"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onMessageReceived = onMessageReceived;
exports.default = Notification;
const jsx_runtime_1 = require("react/jsx-runtime");
async function onMessageReceived(message) {
}
;
function Notification() {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
}
